import { useCallback, useMemo } from 'react';

import moment from 'moment'

import { HeaderActions } from '@/components/reports/header';
import appStore from 'stores/app'

import HeaderContainerGrid from '../headerContainer/Grid';
import HierarchicalHeader from '../hierarchical-report/Header';

export default function Header({ value, isLoading, onApply, title, children }) {
  const dates = useMemo(() => {
    const { startDate, endDate } = value
    return {
      startDate: startDate ? moment.utc(startDate).tz(appStore.timezone) : null,
      endDate: endDate ? moment.utc(endDate).tz(appStore.timezone) : null,
    }
  }, [value])

  const handleChange = useCallback(({ startDate, endDate }) => {
    if (startDate && endDate) {
      onApply({ startDate: startDate.startOf('day'), endDate: endDate.endOf('day') })
    }
  }, [onApply])

  return <>
    <HeaderContainerGrid title={`${title} Report`}>
      <HeaderActions>
        <HierarchicalHeader dates={dates} isLoading={isLoading} onChange={handleChange} />
        {children}
      </HeaderActions>
    </HeaderContainerGrid>
  </>
}
